<script>
import CommonConstants from '../../../common/Constants';
import config from '../../../common/genericPanelConf';
import Utils from '../../../common/Utils';
import { required } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import Service from '@/services/planning';
import CommonService from '@/services/common';
import { FilterMatchMode, FilterOperator } from 'primevue/api';

import ResponsiveButton from '../../../components/generic/ResponsiveButton.vue'
import GenericDataTable from '../../../components/generic/GenericDataTable.vue';
import GenericCustomAutocompleteV2 from '../../../components/generic/GenericCustomAutocompleteV2.vue';
import GenericBooleanDropdownNull from '../../../components/generic/GenericBooleanDropdownNull.vue';
import Calendar from 'primevue/calendar';

export default{
    setup: () => ({ v$: useVuelidate() }),
  components: {
    //GenericDataTable,
    ResponsiveButton,
    GenericCustomAutocompleteV2
    //GenericBooleanDropdownNull
  },
  data(){
    return {
        filters: {
            monthDate: Utils.setFirstDayOfMonth(Utils.formatDatePlusMonths(new Date(), -1)),
            endingInventoryDate: Utils.setFirstDayOfMonth(Utils.formatDatePlusMonths(new Date(), -1)),
            idPlanningTrueUpFeedstocksWeightedAverageValue: null,
            isFinal: false
        },

        filtersImport:{
            monthStartDate: Utils.setFirstDayOfMonth(Utils.formatDatePlusMonths(new Date(), -1)),
            endingInventoryDate: Utils.setLastDayOfMonth(Utils.formatDatePlusMonths(new Date(), 0)),
            poolName: null,
            isFinal: false
        },

        showImportDialog: false,
        loading: false,
        sum: [],
        sumConsumptions: [],
        openEditDialog: false,
        openExportDialog2: false,
        editItem: {},
        exportFilters: {
            idVesselSummaryVoyage: null,
            settlementDate: null,
            isFinal: false
        },
        optionCombo: [],
        feedstocksWeightedAverageValue: [],
        selectedItem: null,
        initialStock: [],
        finalStock: {},
        supplies: [],
        consumptions: [],

        weeklyData: {
            totalVolume: null,
            weightedAveragePremiumOrDiscount: null
        },
        suppliesFilters:{
            gradeDescription: { value: null, matchMode: FilterMatchMode.CONTAINS },
            vesselDescription: { value: null, matchMode: FilterMatchMode.CONTAINS },
            laycanFrom: {  operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }] },
            laycanTo: {  operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }]  },
            tradeId: { value: null, matchMode: FilterMatchMode.CONTAINS },
            dealId: { value: null, matchMode: FilterMatchMode.CONTAINS },
            volume: { value: null, matchMode: FilterMatchMode.CONTAINS },
            premiumOrDiscount: { value: null, matchMode: FilterMatchMode.CONTAINS }
        }       
    }
  },
  validations(){
    return {
        
    }
  },
  watch:{
    'filters.endingInventoryDate'(){
        this.loadFeedstocksWeightedAverageValue();
    },
    'filters.idPlanningTrueUpFeedstocksWeightedAverageValue'(){
        this.loadFeedstocksWtdDetail();
    }
  },
  computed: {
    constants(){
        return CommonConstants;
    },
    fieldsForDialogEdit(){
        let fields =  [];

        if(this.configurationDetail && this.configurationDetail.columns){
            fields = this.configurationDetail.columns.filter(col => col.inLineEdit)
        }
        return fields;
    },
    utils(){
      return Utils;
    },
    uiPermissions(){
      return this.$store.getters['security/uiPermissions'];
    }
  },
  created(){
    this.configurationHeader = config.getConfiguration('FeedstocksWeightedAverage');
    this.configurationDetail = config.getConfiguration('FeedstocksWtdDetail');
  },
  mounted(){
    this.$store.dispatch('security/setNavbarTitle', 'PremiumDiscountCalculationDetails.page_title');
    this.loadFeedstocksWeightedAverageValue();
  },
  methods: {
    loadFeedstocksWeightedAverageValue(){
        let filters = [];
        
        filters.push({
            operator: '=',
            value: Utils.formatDateForAPI(this.filters.monthDate),
            property: 'MonthStartDate',
        });

        filters.push({
            operator: '=',
            value: this.filters.endingInventoryDate,
            property: 'EndingInventoryDate',
        });

        filters.push({
            operator: '=',
            value: this.filters.isFinal,
            property: 'IsFinal',
        });

        let body = {
            filter: JSON.stringify(filters)
        }
 
        this.optionCombo = [];
        this.filters.idPlanningTrueUpFeedstocksWeightedAverageValue = null;

        CommonService.loadGeneric(this.configurationHeader.api, body, response => {
            if(response.success){
                this.feedstocksWeightedAverageValue = response.data;
                this.optionCombo = response.data
            }
        });
    },
    loadFeedstocksWtdDetail(){
        let poolName = '';

        for(let i = 0; i < this.feedstocksWeightedAverageValue.length; i++){
            let item = this.feedstocksWeightedAverageValue[i];

            if(item.id == this.filters.idPlanningTrueUpFeedstocksWeightedAverageValue){
                poolName = item.planningTrueUpFamilyPoolConfiguration;
                break;
            }
        }

        let body = {
            poolName: poolName,
            monthDate: Utils.formatDateForAPI(this.filters.monthDate),
            endingInventoryDate: this.filters.endingInventoryDate,
            isFinal: false
        }

        this.initialStock = [];
        this.finalStock = [];
        this.consumptions = [];
        this.supplies = [];
        this.sum = [];
        this.sumConsumptions = [];
        let totalVolume = 0;
        let totalVolumeConsumption = 0;

        this.$store.dispatch("generic/setLoading", true);
        Service.getFeedstocksWeightedAverageValueTanks(body, (response) => {
            this.$store.dispatch("generic/setLoading", false);
            if (response.success) {
                this.supplies = response.data.supplies;
                this.consumptions = response.data.consumptions;

                if(response.data.offtakes.length > 0){
                    for(let i = 0; i < response.data.offtakes.length; i++){
                        this.consumptions.push(response.data.offtakes[i]);
                    }
                }

                this.initialStock.push(response.data.initialStock);
                this.finalStock.push(response.data.finalStock);

                if(response.data.supplies.length > 0){
                    for(let i = 0; i < response.data.supplies.length; i++){
                        totalVolume += response.data.supplies[i].volume;
                    }
                }

                if(this.consumptions.length > 0){
                    for(let i = 0; i < this.consumptions.length; i++){
                        totalVolumeConsumption += this.consumptions[i].volume;
                    }
                }

                this.sum.push({
                    gradeDescription: null,
                    vesselDescription: null,
                    laycanFrom: null,
                    laycanTo: null,
                    dealId: null,
                    tradeId: null,
                    volume: totalVolume + this.initialStock[0].volume,
                    premiumOrDiscount: this.finalStock[0].premiumOrDiscount
                });

                this.sumConsumptions.push({
                    gradeDescription: null,
                    vesselDescription: null,
                    laycanFrom: null,
                    laycanTo: null,
                    dealId: null,
                    tradeId: null,
                    volume: totalVolumeConsumption,
                    premiumOrDiscount: this.finalStock[0].premiumOrDiscount
                });
                
                let filters = [];
        
                filters.push({
                    operator: 'eq',
                    value: this.filters.idPlanningTrueUpFeedstocksWeightedAverageValue,
                    property: 'IdPlanningTrueUpFeedstocksWeightedAverageValue',
                });

                this.$refs.feedstocksWtdDetail.filterFromView(filters);
            } else {
                this.$toast.add({ detail: response.message && response.message != '' ? response.message : this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
            }
        })
    },

    // loadWeeklyData(){
    //     this.weeklyData = {
    //         totalQuantity: null,
    //         weightedAverageDensity: null,
    //         weightedAveragePremiumOrDiscount: null
    //     };
    //     for(let i = 0; i < this.productsWeightedAverageValue.length; i++){
    //         let item = this.productsWeightedAverageValue[i];

    //         if(item.id == this.filters.idPlanningTrueUpProductsWeightedAverageValue){
    //             this.weeklyData.totalQuantity = Utils.formatDecimal(item.totalQuantity, 3);
    //             this.weeklyData.weightedAverageDensity = Utils.formatDecimal(item.weightedAverageDensity, 4);
    //             this.weeklyData.weightedAveragePremiumOrDiscount = Utils.formatDecimal(item.weightedAveragePremiumOrDiscount, 3);
    //         }
    //     }
    // },
    onRowEdit(data){
        this.$store.dispatch("generic/setLoading", true);
        Service.updateFeedstocksWeightedAverageDetailValue(data, (response) => {
            this.$store.dispatch("generic/setLoading", false);
            if (response.success) {
                this.loadFeedstocksWtdDetail();
                this.$toast.add({ severity: 'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000 });
            } else {
                this.$toast.add({ detail: response.message && response.message != '' ? response.message : this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
            }
        })
    },
    exportExcel(){
        let poolName = '';

        for(let i = 0; i < this.feedstocksWeightedAverageValue.length; i++){
            let item = this.feedstocksWeightedAverageValue[i];

            if(item.id == this.filters.idPlanningTrueUpFeedstocksWeightedAverageValue){
                poolName = item.planningTrueUpFamilyPoolConfiguration;
                break;
            }
        }

        let body = {
            monthDate: Utils.formatDateForAPI(Utils.dateToCurrentTimeZone(this.filters.monthDate)),
            poolName : poolName,
            isFinal: false,
            endingInventoryDate: this.filters.endingInventoryDate
        };

      this.$store.dispatch("generic/setLoading", true);
      let fileNameWithExtension = Utils.formatDateMonth(this.monthDate) + " Feedstocks.xlsx";
      Service.exportFeedstocksWeightedAverageValue(body, ({success, data, message}) => {
          this.$store.dispatch("generic/setLoading", false);
  
          if(success){
              var fileURL = window.URL.createObjectURL(new Blob([data]));
              var fileLink = document.createElement('a');
              fileLink.href = fileURL;
              fileLink.setAttribute('download', fileNameWithExtension);
              document.body.appendChild(fileLink);
          
              fileLink.click();
          } else{
              this.$toast.add({ detail: message || this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
          }
      })
    },
    importFeedstocksWtdDetail(){
        this.$confirm.require({
        message: this.$t('messages.confirm_import'),
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: this.$t('yes'),
        rejectLabel: this.$t('no'),
        accept: () => {                  
          let body = {
            monthStartDate: Utils.formatDateForAPI(this.filtersImport.monthStartDate),
            endingInventoryDate: this.filtersImport.endingInventoryDate,
            poolName: this.filtersImport.poolName,
            isFinal: false
          }

          this.$store.dispatch("generic/setLoading", true);
          Service.importFeedstocksWeightedAverageDetailValue(body, 
            response => {   
              this.$store.dispatch("generic/setLoading", false);      
              if(response.success){
                this.showImportDialog = false;
                this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.create_message_success'), life: 3000});
              }else{
                this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
              }
            })
        },
        reject: () => {
            this.$confirm.close();
        }
      });
    },

    onDelete(data){
        console.log(data);
        this.$confirm.require({
            message: this.$t('messages.delete_message_question'),
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: this.$t('yes'),
            rejectLabel: this.$t('no'),
            accept: () => {
                CommonService.deleteItem(this.configurationDetail.api, data.id, response => {
                        if(response.success){
                            this.$emit('onDeleteRecord');
                            this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.delete_message_success'), life: 3000});
                            this.loadFeedstocksWtdDetail();
                        }else{
                            this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                        }
                    })
            },
            reject: () => {
                //callback to execute when user rejects the action
            }
        });
    },
    onEditDialog(data){
        if(this.configurationDetail.editMode == 'dialog'){
            this.editItem = {...data};
            this.originalEditItem = {...data};
            for(let i=0; i<this.fieldsForDialogEdit.length; i++){
                if(this.fieldsForDialogEdit[i].type == 'date'){
                    let field = this.fieldsForDialogEdit[i];
                    this.editItem[field.name] = this.editItem[field.name] ? new Date(Utils.dateToCurrentTimeZone(this.editItem[field.name])) : null;
                    this.originalEditItem[field.name] = this.editItem[field.name] ? new Date(Utils.dateToCurrentTimeZone(this.originalEditItem[field.name])) : null;
                }else if(this.fieldsForDialogEdit[i].type == 'select'){
                    let field = this.fieldsForDialogEdit[i];
                    if(field.selectApiFn){
                        field.selectApi = field.selectApiFn(data)
                    }
                    field.disableStore = field.refreshOnUpdateDialog ? true: false;
                }               
            }           
            this.openEditDialog = true;
        }else{
            let uri = `/${this.category}/${this.name}/${data[this.configurationDetail.idColumn]}`;
            this.$router.push(uri);
        }
    },
    dialogEditSave(){
        this.$store.dispatch("generic/setLoading", true);
        CommonService.updateItem(this.configurationDetail.api, this.editItem, (response) => {
            this.$store.dispatch("generic/setLoading", false);
            if(response.success){
                this.loadFeedstocksWtdDetail();
                this.openEditDialog = false;
                this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000});
            }else{
                this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
            }
        })
    },
    setStyle(value){
        if(value < 0){
            return "color: red";
        }

        return "";
    }
  }
}

</script>

<template>
    <main>
        <div class="m-5">
            <div class="grid">

                <Dialog v-model:visible="showImportDialog" modal>
                    <div class="field">
                        <label for="monthStartDate">{{ $t('FeedstocksWeightedAverage.monthStartDate') }}</label>
                        <Calendar 
                        class="w-full" 
                        v-model="this.filtersImport.monthStartDate" 
                        name="monthStartDate" dateFormat="mm/yy" :showTime="false"
                        :showIcon="true" :showButtonBar="true" :yearNavigator="true" 
                        view="month" 
                        placeholder="mm/yy"/> 
                    </div>

                    <div class="field">
                        <label for="endingInventoryDate">{{ $t('FeedstocksWeightedAverage.referenceDate') }}</label>
                        <Calendar 
                        class="w-full" 
                        v-model="this.filtersImport.endingInventoryDate"
                        :showIcon="true" :showButtonBar="true" :yearNavigator="true" 
                        dateFormat="dd/mm/yy" 
                        placeholder="dd/mm/yyyy"/> 
                    </div>

                    <div class="field">
                        <label for="poolName">{{ $t('FeedstocksWeightedAverage.planningTrueUpFamilyPoolConfiguration') }}</label>
                        <!--<InputText v-model="this.filtersImport.poolName" class="w-full" />-->
                        <GenericCustomAutocompleteV2 
                            name="FamilyPoolConfigurationCombo"
                            v-model="this.filtersImport.poolName" 
                            class="w-full"
                            :format="{ label: 'label', value: 'value' }"
                            :api="`true-up/family-pool-configuration-combo?monthStartDate=${utils.formatDateForAPI(this.filtersImport.monthStartDate)}&isProduct=false`" />
                    </div>

                    <template #footer>
                        <ResponsiveButton :label="$t('btn.cancel')" icon="pi pi-times" class="p-button-text" @click="showImportDialog = false"/>
                        <ResponsiveButton :label="$t('btn.import')" icon="pi pi-plus" class="p-button-text" @click="importFeedstocksWtdDetail()" />
                    </template>

                </Dialog>

                <Dialog v-model:visible="openEditDialog" :style="{width: '85vw'}" :modal="true" v-if="openEditDialog">
                    <div class="grid">
                        <div class="col-12 lg:col-4" v-for="field in fieldsForDialogEdit" :key="field.name">
                            <label :for="field.name">{{$t(field.label)}}</label>
                            <InputText 
                                :disabled="field.editEnabled ? !field.editEnabled(editItem) : false"
                                v-if="field.type == 'string'" 
                                class="w-full"
                                v-model="editItem[field.name]" />
                            <InputText 
                                :disabled="field.editEnabled ? !field.editEnabled(editItem) : false"
                                class="w-full" 
                                type="number" 
                                v-if="field.type == 'number'"
                                v-model="editItem[field.name]" />
                            <InputNumber
                                :disabled="field.editEnabled ? !field.editEnabled(editItem) : false"
                                class="w-full" 
                                mode="decimal" :maxFractionDigits="field.digits"
                                v-if="field.type == 'decimal'"
                                v-model="editItem[field.name]" />
                            <!--<GenericDateTimeMaskV2 
                                v-if="field.type == 'date'"    
                                v-model="editItem[field.name]"
                                mask="99/99/9999 99:99:99"
                                :unmask="true" />-->
                            <Calendar 
                                :disabled="field.editEnabled ? !field.editEnabled(editItem) : false"
                                class="w-full" 
                                v-if="field.type == 'date'"    
                                :placeholder="constants.DATE_PLACEHOLDER_POINT_ONLY_DATE"
                                :dateFormat="constants.DATE_FORMAT_POINT"
                                :showTime="field.onlyDate ? false : true"
                                v-model="editItem[field.name]" />
                            <GenericBooleanDropdown
                                :disabled="field.editEnabled ? !field.editEnabled(editItem) : false"
                                v-if="field.type == 'boolean'"
                                v-model="editItem[field.name]" 
                                class="w-full" />
                            <GenericCustomMasterDataAutocompleteV2
                                :ref="field.name + '_dialogEdit'"
                                :disabled="field.editEnabled ? !field.editEnabled(editItem) : false"
                                v-if="field.type == 'select'"
                                :name="field.name"
                                v-model="editItem[field.updateField ?? field.name]" 
                                :api="field.selectApi"
                                :disableStore="field.disableStore"
                                :format="field.selectFormat" />
                            <GenericCustomAutocompleteV2
                                class="w-full"
                                :disabled="field.editEnabled ? !field.editEnabled(editItem) : false"
                                v-if="field.type == 'select-simple'"
                                :name="field.name"
                                v-model="editItem[field.updateField ?? field.name]" 
                                :api="field.selectApi"
                                :format="field.selectFormat" />
                            <Textarea
                                :disabled="field.editEnabled ? !field.editEnabled(editItem) : false"
                                class="w-full" 
                                v-if="field.type == 'textarea'"
                                v-model="editItem[field.name]" />
                        </div>
                    </div>
                    <template #footer>
                        <Button :label="$t('btn.save')" icon="pi pi-save" @click="dialogEditSave" autofocus />
                    </template>
                </Dialog>

                <div class="col-2">
                    <label for="dateFrom">{{$t('month')}}</label>
                    <Calendar
                    class="p-inputtext-sm w-full"
                    placeholder="__/__/____"
                    v-model="this.filters.monthDate"
                    name="endingInventoryDate" dateFormat="mm/yy" :showTime="false"
                    :showIcon="true" :showButtonBar="true" :yearNavigator="true" 
                    view="month" 
                    @data-select="loadFeedstocksWeightedAverageValue" />
                </div>

                <div class="col-2">
                    <label for="endingInventoryDate">{{$t('FeedstocksWeightedAverage.referenceDate')}}</label>
                    <Calendar
                    class="p-inputtext-sm w-full"
                    placeholder="__/__/____"
                    v-model="this.filters.endingInventoryDate"
                    name="endingInventoryDate" dateFormat="dd/mm/yy" :showTime="false"
                    :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
                </div>

                <div class="col-2">
                    <label for="familyPool">{{$t('FeedstocksWeightedAverage.planningTrueUpFamilyPoolConfiguration')}}</label>
                    <GenericCustomAutocompleteV2
                    class="p-inputtext-sm w-full"
                    v-model="filters.idPlanningTrueUpFeedstocksWeightedAverageValue"
                    :staticOptions="optionCombo"
                    name="masterdata-product-combo" 
                    :format="{label: 'planningTrueUpFamilyPoolConfiguration', value: 'id' }" />
                </div>

                <div class="col-8 lg:col-4 m-3">
                    <ResponsiveButton :label="$t('btn.refresh')" icon="pi pi-replay" class="m-2 p-button-sm" @click="loadFeedstocksWtdDetail()"/>
                    <ResponsiveButton :label="$t('btn.import')" icon="pi pi-plus" class="m-2 p-button-sm p-button-success" @click="showImportDialog = true"
                    v-if="!uiPermissions('feedstocksWeightedAverageValueImportButton').isHidden" />
                    <ResponsiveButton :label="$t('btn.export')" icon="pi pi-file-excel" class="m-2 p-button-sm" @click="exportExcel()"/>
                </div>

                <div class="col-12">
                    <DataTable scrollable scrollHeight="800px" :value="this.initialStock" v-if="this.initialStock.length > 0" class="p-datatable-sm" striped-rows >

                        <Column style="max-width: 140px;" />

                        <Column field="gradeDescription" style="min-width: 100px;">
                            <template #body="{ data, field }">
                                <span style="font-weight: bold">{{ data[field] }}</span>
                            </template>
                        </Column>

                        <Column field="vesselDescription" style="min-width: 100px;" />
                        
                        <Column field="laycanFrom" style="min-width: 100px;" />

                        <Column field="laycanTo" style="min-width: 100px;" />
                        
                        <Column field="dealId" style="min-width: 100px;" />

                        <Column field="tradeId" style="min-width: 100px;" />

                        <Column field="volume" style="min-width: 100px;" >
                            <template #body="{ data, field }">
                                <span style="font-weight: bold">{{data[field] != null ? utils.formatDecimal(data[field], 3) : null}}</span>
                            </template>
                        </Column>

                        <Column field="premiumOrDiscount" style="min-width: 100px;" >
                            <template #body="{ data, field }">
                                <span style="font-weight: bold">{{data[field] != null ? utils.formatDecimal(data[field], 3) : null}}</span>
                            </template>
                        </Column>

                        <Column style="min-width: 100px;">
                            <template #body>
                            </template>
                        </Column>
                    </DataTable> 
                </div>

                <div class="col-12">
                    <!--<GenericDataTable :configuration="configurationDetail" :category="'planning'" :name="'true-up-feedstocks-weighted-average'" 
                    ref="feedstocksWtdDetail" :onDialogEditSave="onRowEdit" /> -->

                    <DataTable scrollable scrollHeight="800px" v-if="this.supplies.length > 0" :value="this.supplies" class="p-datatable-sm" 
                    v-model:filters="suppliesFilters" filterDisplay="row" striped-rows>

                        <Column style="max-width: 140px;">
                            <template #body = "slotProps">
                                <ResponsiveButton icon="pi pi-pencil" class="p-button-sm p-button-rounded p-button-success mx-1" @click="onEditDialog(slotProps.data)"
                                v-if="!uiPermissions('feedstocksWtdDetailEditButton').isHidden" v-tooltip="$t('btn.edit')" />  
                                <ResponsiveButton v-if="slotProps.data.isPremiumConverted" icon="pi pi-eye" class="p-button-sm p-button-rounded p-button mx-1" 
                                @click="openExportDialog(slotProps.data)" v-tooltip="$t('FeedstocksWeightedAverage.premiumConverted')" />         
                            </template>                        
                        </Column>

                        <Column field="gradeDescription"  style="min-width: 100px;" :header="$t('FeedstocksWeightedAverage.grade')" >
                            <template #filter="{ filterModel, filterCallback }">
                                <InputText v-model="filterModel.value" type="text" @input="filterCallback()" class="p-column-filter" placeholder="Search"/>
                            </template>
                        </Column>

                        <Column field="vesselDescription"  style="min-width: 100px;" :header="$t('FeedstocksWeightedAverage.vessel')">
                            <template #filter="{ filterModel, filterCallback }">
                                <InputText v-model="filterModel.value" type="text" @input="filterCallback()" class="p-column-filter" placeholder="Search"/>
                            </template>
                        </Column>

                        <Column field="laycanFrom" :header="$t('FeedstocksWeightedAverage.laycanFrom')"  style="min-width: 100px;" >
                            <template #body="{ data, field }">
                                <span>{{data[field] != null ? utils.formatDate(utils.dateToCurrentTimeZone(data[field])) : null}}</span>
                            </template>
                        </Column>

                        <Column field="laycanTo" :header="$t('FeedstocksWeightedAverage.laycanTo')"  style="min-width: 100px;" >
                            <template #body="{ data, field }">
                                <span>{{data[field] != null ? utils.formatDate(utils.dateToCurrentTimeZone(data[field])) : null}}</span>
                            </template>
                        </Column>

                        <Column field="tradeId" style="min-width: 100px;" :header="$t('FeedstocksWeightedAverage.tradeId')" >
                            <template #filter="{ filterModel, filterCallback }">
                                <InputText v-model="filterModel.value" type="text" @input="filterCallback()" class="p-column-filter" placeholder="Search"/>
                            </template>
                        </Column>

                        <Column field="dealId" :header="$t('FeedstocksWeightedAverage.dealId')" style="min-width: 100px;">
                            <template #filter="{ filterModel, filterCallback }">
                                <InputText v-model="filterModel.value" type="text" @input="filterCallback()" class="p-column-filter" placeholder="Search"/>
                            </template>
                        </Column>

                        <Column field="volume"  style="min-width: 100px;" :header="$t('FeedstocksWeightedAverage.volume')" >
                            <template #body="{ data, field }">
                                <span>{{data[field] != null ? utils.formatDecimal(data[field], 3) : null}}</span>
                            </template>
                            <template #filter="{ filterModel, filterCallback }">
                                <InputText v-model="filterModel.value" type="number" @input="filterCallback()" class="p-column-filter" placeholder="Search"/>
                            </template>
                        </Column>

                        <Column field="premiumOrDiscount" :header="$t('FeedstocksWeightedAverage.premiumOrDiscount')"  style="min-width: 100px;" >
                            <template #body="{ data, field }">
                                <span :style="setStyle(data[field])">{{data[field] != null ? utils.formatDecimal(data[field], 3) : null}}</span>
                            </template>
                            <template #filter="{ filterModel, filterCallback }">
                                <InputText v-model="filterModel.value" type="number" @input="filterCallback()" class="p-column-filter" placeholder="Search"/>
                            </template>
                        </Column>

                        <Column style="min-width: 100px;">
                            <template #body = "slotProps">
                                <Button icon="pi pi-trash" class="p-button-sm p-button-rounded p-button-warning mr-1 mb-1" v-tooltip="$t('btn.delete')" 
                                @click="onDelete(slotProps.data)" v-if="!uiPermissions('feedstocksWtdDetailDeleteButton').isHidden" />
                            </template>
                        </Column>

                    </DataTable>

                </div>

                <!--<div class="col-12" v-if="this.consumptions.length > 0">
                    <hr style="border: 1px solid black;">
                </div>

                <div class="col-12">
                    <DataTable scrollable scrollHeight="800px" :value="this.sum" v-if="this.sum.length > 0" class="p-datatable-sm">
                        <Column style="max-width: 140px;" />
                        <Column field="gradeDescription"  style="min-width: 100px;" />
                        <Column field="vesselDescription" style="min-width: 100px;" />

                        <Column field="laycanFrom" style="min-width: 100px;">
                            <template #body="{ data, field }">
                                <span>{{data[field] != null ? utils.formatDate(utils.dateToCurrentTimeZone(data[field])) : null}}</span>
                            </template>
                        </Column>

                        <Column field="laycanTo" style="min-width: 100px;" >
                            <template #body="{ data, field }">
                                <span>{{data[field] != null ? utils.formatDate(utils.dateToCurrentTimeZone(data[field])) : null}}</span>
                            </template>
                        </Column>
                        
                        <Column field="dealId"  style="min-width: 100px;" />
                        <Column field="tradeId" style="min-width: 100px;" />
                        <Column field="volume" style="min-width: 100px; font-weight: bold;" >
                            <template #body="{ data, field }">
                                <span>{{data[field] != null ? utils.formatDecimal(data[field], 3) : null}}</span>
                            </template>
                        </Column>
                        <Column field="premiumOrDiscount"  style="min-width: 100px; font-weight: bold;" >
                            <template #body="{ data, field }">
                                <span>{{data[field] != null ? utils.formatDecimal(data[field], 3) : null}}</span>
                            </template>
                        </Column>

                        <Column style="min-width: 100px;">
                            <template #body >               
                            </template>
                        </Column>
                    </DataTable>      
                </div>

                <div class="col-12">
                    <DataTable scrollable scrollHeight="800px" v-if="this.consumptions.length > 0" :value="this.consumptions" class="p-datatable" striped-rows>
                        <Column style="max-width: 140px;" />
                        <Column field="gradeDescription"  style="min-width: 100px;" />
                        <Column field="vesselDescription" style="min-width: 100px;" />

                        <Column field="laycanFrom" style="min-width: 100px;">
                            <template #body="{ data, field }">
                                <span>{{data[field] != null ? utils.formatDate(utils.dateToCurrentTimeZone(data[field])) : null}}</span>
                            </template>
                        </Column>

                        <Column field="laycanTo" style="min-width: 100px;" >
                            <template #body="{ data, field }">
                                <span>{{data[field] != null ? utils.formatDate(utils.dateToCurrentTimeZone(data[field])) : null}}</span>
                            </template>
                        </Column>
                        
                        <Column field="dealId"  style="min-width: 100px;" />
                        <Column field="tradeId" style="min-width: 100px;" />
                        <Column field="volume" style="min-width: 100px;" >
                            <template #body="{ data, field }">
                                <span>{{data[field] != null ? utils.formatDecimal(data[field], 3) : null}}</span>
                            </template>
                        </Column>
                        <Column field="premiumOrDiscount"  style="min-width: 100px;" >
                            <template #body="{ data, field }">
                                <span>{{data[field] != null ? utils.formatDecimal(data[field], 3) : null}}</span>
                            </template>
                        </Column>

                        <Column style="min-width: 100px;">
                            <template #body>              
                            </template>
                        </Column>
                    </DataTable>                      
                </div>

                <div class="col-12" v-if="this.consumptions.length > 0">
                    <hr style="border: 1px solid black;">
                </div>

                <div class="col-12">
                    <DataTable scrollable scrollHeight="800px" :value="this.sumConsumptions" v-if="this.sumConsumptions.length > 0" class="p-datatable-sm">
                        <Column style="max-width: 140px;" />
                        <Column field="gradeDescription"  style="min-width: 100px;" />
                        <Column field="vesselDescription" style="min-width: 100px;" />

                        <Column field="laycanFrom" style="min-width: 100px;">
                            <template #body="{ data, field }">
                                <span>{{data[field] != null ? utils.formatDate(utils.dateToCurrentTimeZone(data[field])) : null}}</span>
                            </template>
                        </Column>

                        <Column field="laycanTo" style="min-width: 100px;" >
                            <template #body="{ data, field }">
                                <span>{{data[field] != null ? utils.formatDate(utils.dateToCurrentTimeZone(data[field])) : null}}</span>
                            </template>
                        </Column>
                        
                        <Column field="dealId"  style="min-width: 100px;" />
                        <Column field="tradeId" style="min-width: 100px;" />
                        <Column field="volume" style="min-width: 100px; font-weight: bold;" >
                            <template #body="{ data, field }">
                                <span>{{data[field] != null ? utils.formatDecimal(Math.abs(data[field]), 3) : null}}</span>
                            </template>
                        </Column>
                        <Column field="premiumOrDiscount"  style="min-width: 100px; font-weight: bold;" >
                            <template #body="{ data, field }">
                                <span>{{data[field] != null ? utils.formatDecimal(data[field], 3) : null}}</span>
                            </template>
                        </Column>

                        <Column style="min-width: 100px;">
                            <template #body>
                            </template>
                        </Column>

                    </DataTable>      
                </div>-->

                
                <div class="col-12">
                    <DataTable scrollable scrollHeight="800px" v-if="this.finalStock.length > 0" :value="this.finalStock" 
                        class="p-datatable-sm" striped-rows>

                        <Column style="max-width: 140px;" />

                        <Column field="gradeDescription" style="min-width: 100px;" >
                            <template #body="{ data, field }">
                                <span style="font-weight: bold">{{ data[field] }}</span>
                            </template>
                        </Column>

                        <Column field="vesselDescription" style="min-width: 100px;" />
                        
                        <Column field="laycanFrom" style="min-width: 100px;" />

                        <Column field="laycanTo" style="min-width: 100px;" />
                        
                        <Column field="dealId" style="min-width: 100px;" />
                        <Column field="tradeId" style="min-width: 100px;" />
                        <Column field="volume" style="min-width: 100px;" >
                            <template #body="{ data, field }">
                                <span style="font-weight: bold">{{data[field] != null ? utils.formatDecimal(data[field], 3) : null}}</span>
                            </template>
                        </Column>
                        <Column field="premiumOrDiscount" style="min-width: 100px;" >
                            <template #body="{ data, field }">
                                <span style="font-weight: bold">{{data[field] != null ? utils.formatDecimal(data[field], 3) : null}}</span>
                            </template>
                        </Column>

                        <Column style="min-width: 100px;">
                            <template #body>
                            </template>
                        </Column>
                    </DataTable> 
                </div>
               <!-- <div class="col-3 lg:col-2 m-5"> 
                    <Card>
                        <template #content>
                            <div class="grid formgrid" >
                                <div class="col-4 lg:col-6 field">
                                    <span>{{$t('FeedstocksWtdDetail.premium')}}</span>
                                </div>
                                <div class="col-4 lg:col-6 field">
                                    <span style="font-weight: bold;">{{ this.weeklyData.weightedAveragePremiumOrDiscount }}</span>
                                </div>                                  
                            </div>
                            <div class="grid formgrid" >
                                <div class="col-4 lg:col-6 field">
                                    <span>{{$t('FeedstocksWtdDetail.totalVolume')}}</span>
                                </div>
                                <div class="col-4 lg:col-6 field">
                                    <span style="font-weight: bold;">{{ this.weeklyData.totalVolume }}</span>
                                </div>                                  
                            </div>
                        </template>
                    </Card>
                </div> --> 
            </div>
        </div>
    </main>
</template>

<style>

.sim-col-red{
    color: red;
}

</style>